export default "__VITE_ASSET__iYGectPZ__"